
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import ErrorVisualization from '../components/ErrorVisualization.vue'
import LoadingComponent from '../components/LoadingComponent.vue'
import { startCase } from 'lodash'
import { AsyncComponentFactory, AsyncComponentPromise } from 'vue/types/options'
import Colored from './Colored.vue'
import HeightAndWidth from './HeightAndWidth.vue'
import Block from '@/components/Block.vue'
import {
  Slide,
  Component as SlideComponent,
  Block as SlideBlock
} from '../@types/Slide'

@Component({
  components: {
    Block
  }
})
export default class Template extends Mixins(Colored, HeightAndWidth) {
  @Prop() public slides!: Slide[]
  @Prop() public slide!: Slide
  @Prop() public presentationPath: any[]

  /**
   * Title.
   */
  get title(): string {
    return this.slide.title
  }

  /**
   * Subtitle.
   */
  get subtitle(): string {
    return this.slide.subtitle
  }

  /**
   * Footer.
   */
  get footer(): string {
    return (this.slide.footer || '').trim()
  }

  /**
   * Get the list of icons.
   */
  get icons() {
    return (this.slide.icons as any).map(icon => {
      const name = typeof icon === 'object' ? icon.name : icon
      const classes = typeof icon === 'object' ? icon.class : ''

      return {
        name: name,
        class: classes
      }
    })
  }

  /**
   * Block.
   */
  get blocks() {
    return (this.slide.blocks || []).map(block =>
      this.isComponent(block)
        ? this.toVueComponent(block as SlideComponent)
        : block
    )
  }

  /**
   * Check if the content block is a component.
   */
  public isComponent(block: SlideBlock): boolean {
    return block.hasOwnProperty('component')
  }

  /**
   * Turn the component options into a Vue component.
   */
  public toVueComponent(block: SlideComponent): SlideComponent {
    const name = startCase(block.component as string).replace(/ /g, '')

    return {
      ...block,
      component: () => ({
        component: (import(
          /* webpackChunkName: "visualization-[request]", webpackPrefetch: true */ `@/components/Visualization/${name}`
        ) as any) as AsyncComponentPromise,
        error: ErrorVisualization,
        loading: LoadingComponent
      })
    }
  }
}
